import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import { IPatientInteractionDimension } from '../dimensions/patient-interaction';
import { IPatientScopedFact, ITimestampedFact } from './common';

export interface IPatientInteractionEventFact
  extends IPatientScopedFact,
    ITimestampedFact {
  interactionRef: ISerialisedDocumentReference;
  interaction: IPatientInteractionDimension;
}
